/**
 * @module api/exclusiveApi/exclusivePinApi
 */

import secureClient from 'lib/secure-client';
import exclusiveUrl from 'shared_js/helpers/urlHelper/exclusiveUrl';

/**
 * Get User PIN Status
 * https://blueprint.bukalapak.io/exclusive/t/users~pin~get~exclusive~users~pins
 */
function retrievePinStatus() {
  return this.get(`${exclusiveUrl}/users/pins`, 'user');
}

/**
 * Collection of exclusive Pin Api
 */
const exclusivePinApi = secureClient(
  {
    retrievePinStatus,
  },
  'xhrExclusivePinApi',
);

export default exclusivePinApi;
